<div class="data-table-container">
  <!-- Table Header -->
  <div class="table-header" *ngIf="title || showSearch">
    <div class="header-left">
      <h3 class="table-title" *ngIf="title">{{ title }}</h3>
      <span class="table-count" *ngIf="data.length">{{ data.length }} Total</span>
    </div>
    <div class="header-right">
      <div class="search-box" *ngIf="showSearch">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="text" [(ngModel)]="searchQuery" (input)="onSearch()" placeholder="Search records...">
      </div>
      <button class="btn-export" (click)="exportExcel()" title="Export to Excel">
        <i class="fa-solid fa-file-excel"></i>
        <span>Export</span>
      </button>
    </div>
  </div>

  <!-- Table Content -->
  <div class="table-wrapper custom-scroll">
    <table class="premium-table">
      <thead>
        <tr>
          <th *ngFor="let col of columns" [class.sortable]="col.sortable">
            {{ col.label }}
            <i class="fa-solid fa-sort" *ngIf="col.sortable"></i>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="!loading">
        <tr *ngFor="let item of paginatedData; let i = index" [class.row-alt]="i % 2 !== 0">
          <td *ngFor="let col of columns">
            <!-- Cell content by type -->
            <ng-container [ngSwitch]="col.type">
              <!-- Department Names -->
              <span *ngSwitchCase="'departmentIds'">{{ getDepartmentDisplay(item[col.key]) }}</span>

              <!-- Status Badge -->
              <ng-container *ngSwitchCase="'status'">
                <span class="status-badge" [ngClass]="getStatusClass(item)">
                  {{ getUserStatus(item) }}
                </span>
              </ng-container>

              <!-- Text -->
              <span *ngSwitchDefault>{{ item[col.key] || '—' }}</span>

              <!-- Hyperlink (emits 'view' so the host can open a detail modal) -->
              <button *ngSwitchCase="'link'"
                      type="button"
                      class="cell-link"
                      (click)="onAction('view', item)"
                      [title]="'View details'">
                {{ item[col.key] || '—' }}
              </button>

              <!-- Date -->
              <span *ngSwitchCase="'date'">{{ formatDate(item[col.key]) }}</span>

              <!-- Badge -->
              <ng-container *ngSwitchCase="'badge'">
                <app-status-badge [status]="item[col.key]"></app-status-badge>
              </ng-container>

              <!-- Actions -->
              <div class="cell-actions" *ngSwitchCase="'actions'">
                <button class="btn-icon edit" (click)="onAction('edit', item)" title="Edit">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-icon delete" (click)="onAction('delete', item)" title="Delete">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </ng-container>
          </td>
        </tr>
        
        <!-- Empty State -->
        <tr *ngIf="paginatedData.length === 0">
          <td [attr.colspan]="columns.length" class="empty-cell">
            <div class="empty-state">
              <i class="fa-solid fa-folder-open"></i>
              <p>No records found</p>
            </div>
          </td>
        </tr>
      </tbody>
      
      <!-- Skeleton Loading -->
      <tbody *ngIf="loading">
        <tr *ngFor="let i of [1,2,3,4,5]">
          <td [attr.colspan]="columns.length">
            <div class="skeleton-row"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Table Footer / Pagination -->
  <div class="table-footer" *ngIf="totalPages > 1">
    <div class="pagination-info">
      Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, filteredData.length) }} of {{ filteredData.length }}
    </div>
    <div class="pagination-controls">
      <button [disabled]="currentPage === 1" (click)="setPage(currentPage - 1)">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <div class="page-numbers">
        <button *ngFor="let p of [].constructor(totalPages); let i = index" 
                [class.active]="currentPage === i + 1"
                (click)="setPage(i + 1)">
          {{ i + 1 }}
        </button>
      </div>
      <button [disabled]="currentPage === totalPages" (click)="setPage(currentPage + 1)">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
